import styles from "./Icon.module.css";

type IconProps = {
  name:
    | "document-verify"
    | "document-failure"
    | "document-edit"
    | "document-create"
    | "document-manual-validation"
    | "document-ocr-error"
    | "document-missing-mandatory-fields"
    | "document-visualize"
    | "documents-library"
    | "document-analyze"
    | "folder-with-trashcan"
    | "dropzone"
    | "file"
    | "folder"
    | "export"
    | "settings"
    | "home"
    | "logo"
    | "search"
    | "trash-can"
    | "folder"
    | "filter"
    | "calendar"
    | "edit-pen-in-square"
    | "edit-pen"
    | "get-back-arrow"
    | "select-arrow-to-bot"
    | "x-mark"
    | "checkmark"
    | "stars"
    | "create-department"
    | "read-all"
    | "download"
    | "full-size"
    | "pencil";

  size?: number;
  color?: string;
  gradient?: boolean;
  className?: string;
};

const Icon = ({
  name,
  size = 24,
  color = "currentColor",
  gradient = false,
  className,
}: IconProps) => (
  <svg
    className={`${styles.icon} ${className}`}
    width={size}
    height={size}
    fill={gradient ? "url(#icon-gradient)" : color}
  >
    {gradient && (
      <>
        <defs>
          <linearGradient
            id="icon-gradient"
            x1="0"
            y1="20"
            x2={25}
            y2={25}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#EE850E" />
            <stop offset="1" stopColor="#B4358B" />
          </linearGradient>
        </defs>
      </>
    )}
    <use xlinkHref={`/sprite.svg#${name}`} />
  </svg>
);

export default Icon;
